import './styles/App.css';
import Calculator from './components/Calculator.js';
import FaqSection from './components/FaqSection';
function App() {
  return (
    <div className="App">
      <Calculator/>
      <FaqSection/>
    </div>
  );
}

export default App;
